import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
    currentUserId: (state) => state.currentUser.id,
    tryingToLogin: (state) => state.tryingToLogin,
    tryingToSignUp: (state) => state.tryingToSignUp,
    tryingToSignUpOrganization: (state) => state.tryingToSignUpOrganization,
    tryingToSetupInfoOrganization: (state) => state.tryingToSetupInfoOrganization,
    tryingToSetupAdminsOrganization: (state) => state.tryingToSetupAdminsOrganization,
    tryingToSetupSocialOrganization: (state) => state.tryingToSetupSocialOrganization,
    tryingToVerifyPhone: (state) => state.tryingToVerifyPhone,
    successSignup: (state) => state.successSignup,
    successSignupOrganization: (state) => state.successSignupOrganization,
    successSetupInfoOrganization: (state) => state.successSetupInfoOrganization,
    successForgotPassword: (state) => state.successForgotPassword,
    successCreatePassword: (state) => state.successCreatePassword,
    currentNotifications: (state) => state.currentNotifications,
    notificationSettings: (state) => state.notificationSettings,
    successConfirmAccount: (state) => state.successConfirmAccount,
  }),
  ...mapGetters('auth', [
    'loggedIn',
    'isTryingToLogin',
    'isTryingToSignup',
    'isTryingToSignupOrganization',
    'isTryingToSetupInfoOrganization',
    'isTryingToSetupAdminsOrganization',
    'isTryingToSetupSocialOrganization',
    'isTryingToVerifyPhone',
    'canManageCompanies',
    'canEditCompany',
    'canEditGroup',
    'canViewCompany',
  ]),
}

export const authMethods = mapActions('auth', [
  'logIn',
  'logInWithProvider',
  'signUp',
  'logOut',
  'forgotPassword',
  'createPassword',
  'confirmAccount',
  'tryingToLoginError',
  'verifyPhone',
  'verifyCode',
  'resendCode',
  'skipPhone',
  'toggleFollowTag',
  'loginByCode',
  'acceptedHubInvite',
  'rejectedHubInvite',
  'signupOrganization',
  'verifyOrganizationToken',
  'organizationSetupInfo',
  'organizationSetupAdmins',
  'organizationSetupSocial',
])
